import React from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { ClickableContainer } from 'components/clickable-container';
import { headerHeight } from 'components/header';
import RefreshIcon from 'components/icons/refresh';

import { REFRESH_BG_COLOR } from './constants';
import { StyledHeader } from './offers-heading';
import { useOffersUIContext } from './offers-ui-context';

export { headerHeight } from 'components/header';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${Styles.color.red};
`;

const RefreshButton = styled(ClickableContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${headerHeight.mobile};
  height: ${headerHeight.mobile};
  background-color: ${REFRESH_BG_COLOR};

  &:active {
    & > * {
      transform: scale(0.95);
      transition: transform 200ms ease-out;
    }
  }

  &:hover {
    background-color: ${Styles.color.primaryHover};
  }

  ${Styles.desktop`
    width: ${headerHeight.desktop};
    height: ${headerHeight.desktop};
  `}
`;

const StyledRefreshIcon = styled(RefreshIcon)`
  margin-top: 4px;
  fill: ${Styles.color.white};
`;

const RefreshLabel = styled.p`
  margin: 0;
  margin-top: 5px;
  font-family: ${Styles.fontFamily.body};
  font-size: 0.875rem;
  color: ${Styles.color.white};
`;

export const OffersHeaderBar: React.FC = () => {
  const { formatMessage } = useIntl();
  const { refreshOffers } = useOffersUIContext();

  return (
    <Container>
      <StyledHeader>{formatMessage({ id: 'offers' })}</StyledHeader>
      <RefreshButton onClick={refreshOffers} data-testid="manual-refresh-button">
        <StyledRefreshIcon />
        <RefreshLabel aria-hidden>{formatMessage({ id: 'refresh' })}</RefreshLabel>
      </RefreshButton>
    </Container>
  );
};
